export default __webpack_public_path__ + "static/media/avatar-image.8bb0980f.jpg";